import React from 'react';
import { CloseButton } from "../../Styles/ButtonClose/ButtonCloseStyle"
import { cancelOperation } from "../../shared/Constants/Constants"

function close(cancel) {
  cancel(cancelOperation)
}

const ButtonClose = ({cancel}) => {  
  const handleClose = React.useCallback(() => close(cancel))
  return (
      <CloseButton data-testid="close-button" onClick={handleClose}/>
  );
};

export default ButtonClose;
  